<div class="his-code-editor-container" [style.height]="height">
    <div #editor></div>
</div>